// @ts-nocheck
import useGetCurrentProduct from "@store/Framework/Store/Data/Products/ProductsHooks/useGetCurrentProduct";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SubAvailabilityTypes } from "@store/Framework/Types/SubAvailabilityTypes";

export interface InventoryData {
    availabilityType: SubAvailabilityTypes;
    availabilityMessage: string | undefined;
    availabilityMessageColor: string | undefined;
    availabilityMessageBackgroundColor: string | undefined;
    availabilityInfoMessageColor: string | undefined;
    availabilityInfoMessageBackgroundColor: string | undefined;
    qtyOnHand: number | undefined;
    isInStock: boolean;
    isOutOfStock: boolean;
    isBackorder: boolean;
    isWhileSuppliesLast: boolean;
    availabilityDetailMessage: string | undefined;
}

export default (productInfo: ProductInfo | null = null): InventoryData => {
    const productContext = useGetCurrentProduct();
    const definedProductInfo = productContext.productInfo || productInfo || {};
    const { inventory } = definedProductInfo;

    const qtyOnHand = inventory?.qtyOnHand;
    const availability = inventory?.inventoryAvailabilityDtos?.find(
        x => x.unitOfMeasure === definedProductInfo.unitOfMeasure,
    )?.availability;
    const availabilityDetailMessage =
        availability?.infoMessage !== availability?.message ? availability?.infoMessage : undefined;
    const subMessageType: SubAvailabilityTypes = (availability as any)?.subMessageType;
    const availabilityMessageColor = availability?.messageColor;
    const availabilityMessageBackgroundColor = availability?.messageBackgroundColor;
    const availabilityInfoMessageColor = availability?.infoMessageColor;
    const availabilityInfoMessageBackgroundColor = availability?.infoMessageBackgroundColor;
    return {
        availabilityType: subMessageType,
        availabilityMessage: availability?.message,
        availabilityMessageColor,
        availabilityMessageBackgroundColor,
        availabilityInfoMessageColor,
        availabilityInfoMessageBackgroundColor,
        qtyOnHand,
        isInStock: subMessageType === SubAvailabilityTypes.InStock,
        isOutOfStock: subMessageType === SubAvailabilityTypes.OutOfStock,
        isBackorder: subMessageType === SubAvailabilityTypes.Backorder,
        isWhileSuppliesLast: subMessageType === SubAvailabilityTypes.WhileSuppliesLast,
        availabilityDetailMessage,
    };
};
